import { Page } from "@/models/page-models/Page";

export const QuotationMaster: Page = {
  "path": "quotation-master",
  "name": "Quotation Master",
  "props": {
    "data": {
      "title": "Quotation",
      "printable": "FALSE",
      "url": "quotation-master",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.q.customer.0",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToCustomerSalesContracts",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/quotation-master/{{formData.q.customer.0}}"
                      },
                      "name": "redirectToCustomerSalesContracts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Create New Quotation",
                  "disabled": "TRUE",
                  "showIf": "fn(LOGICAL,fn(MATCH_DEPARTMENT,SALES),||,fn(MATCH_ROLE,General Manager))",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Reject Quotation",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.rejectionForm.rejectionReason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "printable": false,
                  "multiple": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.otherRejectionReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.rejectionForm.rejectionReason}},Other)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "itemVariable": "fetchedData.selectedQuotation",      
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectQoutation",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/{{__item._id}}/request/reject",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "rejectQoutation"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Quotation"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "QT Open",
              "bracketValueFormula": "{{fetchedData.openQts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open QT",
                      "disabled": "FALSE",
                      "items": "fetchedData.openQts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Quotation",
                          "type": "url",
                          "url": "/edit-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.tag",
                          "text": "Customer Type"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "__item.termsAndConditions.offerValidity",
                          "text": "Offer Validity",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.termsAndConditions.offerValidity}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Creation Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Reject",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openQtSearchForm.page",
                        "serverItemsLengthVariable": "fetchedData.openQts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.openQtSearchForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenQts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sales-contract/open-quotation",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openQts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openQtSearchForm"
                            },
                            "name": "getOpenQts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Pending",
              "bracketValueFormula": "{{fetchedData.pendingQts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending QT",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingQts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "QT",
                          "type": "custom-url",
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditView",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/edit-sales-contract/{{__item._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openEditView",
                              "executeIf": "fn(HELPER_FN,scEditFlag,{{__item.status}})"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openScwView",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openScwView",
                              "executeIf": "fn(NOT,fn(HELPER_FN,scEditFlag,{{__item.status}}))"
                            }
                          ]
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "__item.termsAndConditions.offerValidity",
                          "text": "Offer Validity",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.termsAndConditions.offerValidity}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Creation Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve Pending QT",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Submitted Draft'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Pending Approval'),||,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Pending Revision'))),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveQuotation",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/quotation/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "serviceConfig",
                                "arg4Value": "{\"service\":\"APPROVE_PRICE_CHANGE\",\"args\":[\"__item.items\"]}"
                              },
                              "name": "approveQuotation"
                            }
                          ]
                        },
                        {
                          "label": "Approve Open QT",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'QT Successful'),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "confirmSalesContract",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/quotation/{{__item._id}}/confirm-sales-contract",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "GET",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "confirmSalesContract"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),||,fn(LOGICAL,fn(CONCAT,',{{__item.0.requests.0.type}},'),==,'Reject'))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingQtSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingQts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingQtSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingQts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sales-contract/pending-quotation",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingQts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingQtSearch"
                            },
                            "name": "getPendingQts"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Draft",
              "bracketValueFormula": "{{fetchedData.scDrafts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Draft QT",
                      "disabled": "FALSE",
                      "items": "fetchedData.scDrafts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "QT",
                          "type": "url",
                          "url": "/edit-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "__item.termsAndConditions.offerValidity",
                          "text": "Offer Validity",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.termsAndConditions.offerValidity}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Creation Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Submit",
                          "showIf": "fn(LOGICAL,fn(MATCH_DEPARTMENT,SALES),||,fn(MATCH_ROLE,General Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "submitDraft",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/quotation/{{__item._id}}/submit-draft",
                                "arg2Key": "refreshPage",
                                "arg2Value": "TRUE"
                              },
                              "name": "submitDraft"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.draftSearch.page",
                        "serverItemsLengthVariable": "fetchedData.scDrafts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.draftSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getScDrafts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/quotation/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.scDrafts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.draftSearch"
                            },
                            "name": "getScDrafts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Failed",
              "bracketValueFormula": "{{fetchedData.failedQts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Failed QT",
                      "disabled": "FALSE",
                      "items": "fetchedData.failedQts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "QT",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "__item.termsAndConditions.offerValidity",
                          "text": "Offer Validity",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.termsAndConditions.offerValidity}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Creation Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        },
                        {
                          "value": "__item.rejectionReason",
                          "text": "Rejection Reason",
                          "formula": "fn(CONDITIONAL,fn(NOT,{{__item.rejectionReason}}),,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rejectionReason}},'),==,'Other'),fn(CONCAT,{{__item.rejectionReason}}, - ,{{__item.otherRejectionReason}}),{{__item.rejectionReason.0}}))",
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.failedQtForm.page",
                        "serverItemsLengthVariable": "fetchedData.failedQts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.failedQtForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getFailedQts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/quotation/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.failedQts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.failedQtForm"
                            },
                            "name": "getFailedQts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Successful",
              "bracketValueFormula": "{{fetchedData.openSalesContracts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Sales Order",
                      "disabled": "FALSE",
                      "items": "fetchedData.openSalesContracts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "ID",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openSalesContractForm.page",
                        "serverItemsLengthVariable": "fetchedData.openSalesContracts.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenSalesContracts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sales-contract/open",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openSalesContracts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openSalesContractForm"
                            },
                            "name": "getOpenSalesContracts"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.openSalesContracts.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Produced",
              "bracketValueFormula": "{{fetchedData.completeSCs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Complete SO",
                      "disabled": "FALSE",
                      "items": "fetchedData.completeSCs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "ID",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.completeScForm.page",
                        "serverItemsLengthVariable": "fetchedData.completeSCs.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.completeScForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getCompleteSCs",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/quotation/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.completeSCs",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.completeScForm"
                            },
                            "name": "getCompleteSCs"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "QT Cancelled",
              "bracketValueFormula": "{{fetchedData.cancelledSCs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Cancelled SO",
                      "disabled": "FALSE",
                      "items": "fetchedData.cancelledSCs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "ID",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.cancelledScForm.page",
                        "serverItemsLengthVariable": "fetchedData.cancelledSCs.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.cancelledScForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getCancelledSCs",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/quotation/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.cancelledSCs",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.cancelledScForm"
                            },
                            "name": "getCancelledSCs"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultDraftSearchObject",
        "pageFunction": {
          "name": "copyDefaultDraftSearchObject",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultDraftSearchObject",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.draftSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getScDrafts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.scDrafts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.draftSearch"
        },
        "name": "getScDrafts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingQtSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingQtSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingQtSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingQtSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingQts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-contract/pending-quotation",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingQts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingQtSearch"
        },
        "name": "getPendingQts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenQtSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenQtSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openQtSearchForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenQtSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getOpenQts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-contract/open-quotation",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openQts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openQtSearchForm"
        },
        "name": "getOpenQts"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultFailedQtForm",
        "pageFunction": {
          "name": "copyDefaultFailedQtForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFailedQtForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.failedQtForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getFailedQts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.failedQts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.failedQtForm"
        },
        "name": "getFailedQts"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRejectionReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=quotation-rejection-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.qtRejectionReasons"
        },
        "name": "getRejectionReasons"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenSalesContractForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenSalesContractForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openSalesContractForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenSalesContractForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getOpenSalesContracts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-contract/open",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openSalesContracts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openSalesContractForm"
        },
        "name": "getOpenSalesContracts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCompleteScForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCompleteScForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.completeScForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultCompleteScForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCompleteSCs",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.completeSCs",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.completeScForm"
        },
        "name": "getCompleteSCs"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCancelledScForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCancelledScForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.cancelledScForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultCancelledScForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCancelledSCs",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.cancelledSCs",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.cancelledScForm"
        },
        "name": "getCancelledSCs"
      }
    ],
    "functions": [
      {
        "name": "getDefaultDraftSearchObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Draft",
              "Revised Draft"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingQtSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenQtSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "copySelectedTableItem",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedQuotation",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "openRejectionPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Reject Quotation"
      },
      {
        "name": "getDefaultFailedQtForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "QT Failed"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenSalesContractForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCompleteScForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "SC Completed"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCancelledScForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "SC Cancelled"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer", "Closed Prospect", "Closed Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,ACCOUNTING_COSTING,GENERAL_MANAGER,QA_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 74
}